export const SAMPLE_MONTH = {
  "values": {
  "production": {
    "label": "production",
    "deviceTimeValues": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 2.10843580338512
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 2.3845016647318325
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 1.7463439847009752
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 2.767592529534408
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 2.1467503252032575
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 2.5066919898077435
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.7662576323119782
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 0.6808526666666675
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": 2.9102683797970467
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 2.838813517915302
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 1.9898672279308819
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": 2.9775920167286095
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": 3.0108596214584404
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": 2.9976721806781175
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": 2.794992332713752
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.7316410095371004
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 2.5522944114232655
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 2.870188152451779
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 2.8387567804877986
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 2.752873016020432
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 3.0610576480129707
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 2.9968131382113875
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 1.976033181818193
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 2.8224889979123286
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 2.9517077151473113
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 3.1003363701067638
        }
      ],
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 2.0177636494319554
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 1.4014798653355006
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 2.5628929786740932
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 1.972626268241842
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 1.9505927967479802
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 2.4990123720176102
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.7158222098421551
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 1.0923090243902425
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": 2.6032477429137975
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 2.060235325732912
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 2.890785553479692
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": 2.8081960339219404
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": 2.8071691477008935
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": 2.757175037157451
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": 2.486362576672863
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.7557346708536863
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 2.4700539354539105
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 2.677572261213109
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 2.5286469918699213
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 2.834295384258195
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 2.876561605839423
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 2.854940666666674
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 1.7097055681818163
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 2.905098042217598
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 2.7439947715147423
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.3709034946619211
        }
      ]
    },
    "deviceNames": {
      "0518d382-c229-4b95-a6b6-34390d8f2767": "Solar-Ost",
      "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac": "Solar-West"
    },
    "timeBucket": "1 day"
  },
  "consumption": {
    "label": "consumption",
    "deviceTimeValues": {
      "4581f36f-9661-470f-b1ba-c358992a4712": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": -0.05584150939021396
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 3.3708415648943633
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 2.1723086694483336
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 3.5294499675700786
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 3.5220393356562313
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 1.8247020963632224
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.5360193105849697
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 0.5526459210220772
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": -0.5008766872739861
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 0.9924697231270414
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 1.5742979939280701
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": -0.23644021840148636
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": -0.12609718532280579
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": -0.36377390849976734
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": -0.14469273698884783
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.03723011397999444
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 2.3621554980264614
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 2.6848095514757133
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 1.3867296701509858
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 3.609054601811004
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 2.2768255497624828
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 1.0199897212543563
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 0.33141823979591106
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 3.7262533333333536
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 3.3038048527023916
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 1.8553383274021355
        }
      ]
    },
    "deviceNames": {
      "4581f36f-9661-470f-b1ba-c358992a4712": "Allgemein"
    },
    "timeBucket": "1 day"
  },
  "batteryCharge": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-05-31T00:00:00.000Z",
          "value": 0.08925
        },
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.09285137955019708
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 0.07164847921987462
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 0.052683588317107095
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 0.0585880240908038
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 0.051531823461091754
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 0.06700081074820477
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.09437128597957289
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 0.09028408826945412
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": 0.09563408375131226
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 0.09399092601209865
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 0.09029332087809435
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": 0.09568273698884758
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": 0.09980712958662332
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": 0.09980318160705991
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": 0.09920306691449814
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.09057094673179809
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 0.09849349895518922
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 0.09893585870323031
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 0.09996945412311265
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 0.0957595774320873
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 0.07941524736415248
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 0.08798792102206737
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 0.09034844619666048
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 0.09526084435165855
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 0.09999466481094873
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.09999359430604983
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 day"
  },
  "batteryPower": { } ,
  "batteryPowerPositive": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-05-31T22:00:00.000Z",
          "value": 9.2
        },
        {
          "read": "2025-06-01T22:00:00.000Z",
          "value": 22.3
        },
        {
          "read": "2025-06-02T22:00:00.000Z",
          "value": 27.8
        },
        {
          "read": "2025-06-03T22:00:00.000Z",
          "value": 32.5
        },
        {
          "read": "2025-06-04T22:00:00.000Z",
          "value": 31.4
        },
        {
          "read": "2025-06-05T22:00:00.000Z",
          "value": 30.6
        },
        {
          "read": "2025-06-06T22:00:00.000Z",
          "value": 6
        },
        {
          "read": "2025-06-07T22:00:00.000Z",
          "value": 7.3
        },
        {
          "read": "2025-06-08T22:00:00.000Z",
          "value": 5.2
        },
        {
          "read": "2025-06-09T22:00:00.000Z",
          "value": 10.5
        },
        {
          "read": "2025-06-10T22:00:00.000Z",
          "value": 13.7
        },
        {
          "read": "2025-06-11T22:00:00.000Z",
          "value": 8.2
        },
        {
          "read": "2025-06-12T22:00:00.000Z",
          "value": 1.4
        },
        {
          "read": "2025-06-13T22:00:00.000Z",
          "value": 1.8
        },
        {
          "read": "2025-06-14T22:00:00.000Z",
          "value": 1.5
        },
        {
          "read": "2025-06-15T22:00:00.000Z",
          "value": 12.8
        },
        {
          "read": "2025-06-16T22:00:00.000Z",
          "value": 4.3
        },
        {
          "read": "2025-06-17T22:00:00.000Z",
          "value": 2.8
        },
        {
          "read": "2025-06-18T22:00:00.000Z",
          "value": 0.8
        },
        {
          "read": "2025-06-19T22:00:00.000Z",
          "value": 1.4
        },
        {
          "read": "2025-06-20T22:00:00.000Z",
          "value": 22.3
        },
        {
          "read": "2025-06-21T22:00:00.000Z",
          "value": 14.7
        },
        {
          "read": "2025-06-22T22:00:00.000Z",
          "value": 16
        },
        {
          "read": "2025-06-23T22:00:00.000Z",
          "value": 13.8
        },
        {
          "read": "2025-06-24T22:00:00.000Z",
          "value": 0.3
        },
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0.2
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 day"
  },
  "batteryPowerNegative": {
    "label": "battery",
    "deviceTimeValues": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": [
        {
          "read": "2025-05-31T22:00:00.000Z",
          "value": 9
        },
        {
          "read": "2025-06-01T22:00:00.000Z",
          "value": 37
        },
        {
          "read": "2025-06-02T22:00:00.000Z",
          "value": 38.8
        },
        {
          "read": "2025-06-03T22:00:00.000Z",
          "value": 21.7
        },
        {
          "read": "2025-06-04T22:00:00.000Z",
          "value": 32
        },
        {
          "read": "2025-06-05T22:00:00.000Z",
          "value": 11.6
        },
        {
          "read": "2025-06-06T22:00:00.000Z",
          "value": 5.6
        },
        {
          "read": "2025-06-07T22:00:00.000Z",
          "value": 7.2
        },
        {
          "read": "2025-06-08T22:00:00.000Z",
          "value": 4.6
        },
        {
          "read": "2025-06-09T22:00:00.000Z",
          "value": 9.6
        },
        {
          "read": "2025-06-10T22:00:00.000Z",
          "value": 16.5
        },
        {
          "read": "2025-06-11T22:00:00.000Z",
          "value": 2.8
        },
        {
          "read": "2025-06-12T22:00:00.000Z",
          "value": 1.2
        },
        {
          "read": "2025-06-13T22:00:00.000Z",
          "value": 1.6
        },
        {
          "read": "2025-06-14T22:00:00.000Z",
          "value": 2.4
        },
        {
          "read": "2025-06-15T22:00:00.000Z",
          "value": 12.9
        },
        {
          "read": "2025-06-16T22:00:00.000Z",
          "value": 3.8
        },
        {
          "read": "2025-06-17T22:00:00.000Z",
          "value": 2.2
        },
        {
          "read": "2025-06-18T22:00:00.000Z",
          "value": 0.5
        },
        {
          "read": "2025-06-19T22:00:00.000Z",
          "value": 6.6
        },
        {
          "read": "2025-06-20T22:00:00.000Z",
          "value": 21.4
        },
        {
          "read": "2025-06-21T22:00:00.000Z",
          "value": 12.9
        },
        {
          "read": "2025-06-22T22:00:00.000Z",
          "value": 10.4
        },
        {
          "read": "2025-06-23T22:00:00.000Z",
          "value": 13.3
        },
        {
          "read": "2025-06-24T22:00:00.000Z",
          "value": 0.1
        },
        {
          "read": "2025-06-25T22:00:00.000Z",
          "value": 0
        }
      ]
    },
    "deviceNames": {
      "8db8d3dd-9775-4809-a449-fac24d30513c": "2Kanter-Batterie"
    },
    "timeBucket": "1 day"
  },
  "grid": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": -4.166540806862972
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": -1.0409375435337822
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": -2.5058783031988874
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": -1.066328816307621
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": -0.6108478513356562
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": -2.108680681028492
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": -0.9376922005571031
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": -1.2253576074332173
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": -5.9862980286947395
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": -3.868729641693811
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": -3.4244628678187764
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": -5.754025789962825
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": -5.931811774268463
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": -6.118411402693915
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": -5.502571096654275
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": -1.398173993952082
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": -2.679415138147202
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": -2.8151586102719034
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": -3.97283193960511
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": -2.493570931042489
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": -3.422217240180744
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": -4.775028571428571
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": -3.082951646567718
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": -1.904966017165391
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": -2.382607979587103
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": -1.6007014234875444
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 day"
  },
  "gridPositive": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.247266101694915
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 0.709030164765526
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 1.65661140867702
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 0.380620531400966
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 1.56060319928905
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 1.53488814876492
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.0792168949771689
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 0.108978979820628
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": 0.0744329896907217
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 0.117779892428631
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 0.234418161007249
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": 0.25704392971246
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": 0.228240422721268
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": 0.25708188976378
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": 0.18315
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.449892664509169
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 0.425789296249473
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 0.47226443768997
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 0.144018292682927
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 0.0831045643153527
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 0.072310205908684
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 0.0762550073277968
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 0.0904821763602251
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 0.285343223736969
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 0.642
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.687428571428571
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 day"
  },
  "gridNegative": {
    "label": "grid",
    "deviceTimeValues": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": [
        {
          "read": "2025-06-01T00:00:00.000Z",
          "value": 0.247266101694915
        },
        {
          "read": "2025-06-02T00:00:00.000Z",
          "value": 0.709030164765526
        },
        {
          "read": "2025-06-03T00:00:00.000Z",
          "value": 1.65661140867702
        },
        {
          "read": "2025-06-04T00:00:00.000Z",
          "value": 0.380620531400966
        },
        {
          "read": "2025-06-05T00:00:00.000Z",
          "value": 1.56060319928905
        },
        {
          "read": "2025-06-06T00:00:00.000Z",
          "value": 1.53488814876492
        },
        {
          "read": "2025-06-07T00:00:00.000Z",
          "value": 0.0792168949771689
        },
        {
          "read": "2025-06-08T00:00:00.000Z",
          "value": 0.108978979820628
        },
        {
          "read": "2025-06-09T00:00:00.000Z",
          "value": 0.0744329896907217
        },
        {
          "read": "2025-06-10T00:00:00.000Z",
          "value": 0.117779892428631
        },
        {
          "read": "2025-06-11T00:00:00.000Z",
          "value": 0.234418161007249
        },
        {
          "read": "2025-06-12T00:00:00.000Z",
          "value": 0.25704392971246
        },
        {
          "read": "2025-06-13T00:00:00.000Z",
          "value": 0.228240422721268
        },
        {
          "read": "2025-06-14T00:00:00.000Z",
          "value": 0.25708188976378
        },
        {
          "read": "2025-06-15T00:00:00.000Z",
          "value": 0.18315
        },
        {
          "read": "2025-06-16T00:00:00.000Z",
          "value": 0.449892664509169
        },
        {
          "read": "2025-06-17T00:00:00.000Z",
          "value": 0.425789296249473
        },
        {
          "read": "2025-06-18T00:00:00.000Z",
          "value": 0.47226443768997
        },
        {
          "read": "2025-06-19T00:00:00.000Z",
          "value": 0.144018292682927
        },
        {
          "read": "2025-06-20T00:00:00.000Z",
          "value": 0.0831045643153527
        },
        {
          "read": "2025-06-21T00:00:00.000Z",
          "value": 0.072310205908684
        },
        {
          "read": "2025-06-22T00:00:00.000Z",
          "value": 0.0762550073277968
        },
        {
          "read": "2025-06-23T00:00:00.000Z",
          "value": 0.0904821763602251
        },
        {
          "read": "2025-06-24T00:00:00.000Z",
          "value": 0.285343223736969
        },
        {
          "read": "2025-06-25T00:00:00.000Z",
          "value": 0.642
        },
        {
          "read": "2025-06-26T00:00:00.000Z",
          "value": 0.687428571428571
        }
      ]
    },
    "deviceNames": {
      "eab60923-af56-44fb-9d9a-b94294f40e5f": "Hausanschluss"
    },
    "timeBucket": "1 day"
  }
  }
}
